<template>
  <div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fields"
          :actions="actions"
          :items="lstExclusaoSolicitacao"
          responsive
          sortBy="idsolicitacao"
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePDF"
          :titlePDF="titlePDF"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'
export default {
  data() {
    return {
      itemPorPage: 100,
      lstSolicitacaoEspecifica: [],
      solicitaItem: '',
      lstExclusaoSolicitacao: [],
      titlePDF: 'Solicitações Específicas',
      fields: [
        { key: 'idregraexclusaopublicacao', label: 'ID', sortable: true, active: true },
        {
          key: 'solicitacaoexclusao',
          label: 'Solicitação Específica',
          sortable: true,
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'deleteRegraExclusao',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    solicitacao: {
      type: Object,
      require: true
    }
  },
  methods: {
    deleteRegraExclusao(_, item) {
      this.callConfirm(this.mensagemExcluir, item.solicitacaoexclusao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlLaudoMedico +
                'RegrasExclusaoSolicitacaoCondicaoEspecificaPublicacao/Excluir/' +
                item.idregraexclusaopublicacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.sucessoSituacao(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto)
        }
      })
    },
    sucessoSituacao(texto) {
      this.solicitaItem = ''
      this.listaExclusao()
      this.callToast(texto)
    },
    listaExclusao() {
      this.RegrasExclusaoSolicitacaoCondicaoEspecifica(
        this.solicitacao.idsolicitacaopublicacao
      ).then((response) => {
        this.lstExclusaoSolicitacao = response
      })
    }
  },
  mounted() {
    this.listaExclusao()
  }
}
</script>